import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const customerGroup = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 150
        },
        {
            title: '课题组名称',
            dataIndex: 'groupName',
            key: 'groupName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.groupName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '所属单位名称',
            dataIndex: 'customerCompany.companyName',
            key: 'companyName'
        },
        {
            title: '负责人姓名',
            dataIndex: 'principalInvestigator',
            key: 'principalInvestigator',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.principalInvestigator || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        // {
        //     title: '行政职位',
        //     dataIndex: 'administrativePosition',
        //     key: 'administrativePosition',
        //     scopedSlots: {
        //         filterDropdown: 'filterDropdown',
        //         filterIcon: 'filterIcon',
        //         filtered: true,
        //     },
        //     filteredValue: filteredInfo.administrativePosition || [],
        //     sorter: true,
        //     sortDirections: ["descend", "ascend", "descend"]
        // },
        // {
        //     title: '职称',
        //     dataIndex: 'title',
        //     key: 'title',
        //     scopedSlots: {
        //         filterDropdown: 'filterDropdown',
        //         filterIcon: 'filterIcon',
        //         filtered: true,
        //     },
        //     filteredValue: filteredInfo.title || [],
        //     sorter: true,
        //     sortDirections: ["descend", "ascend", "descend"]
        // },
        {
            title: '负责人电话号码',
            dataIndex: 'mobilePhone',
            key: 'mobilePhone',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.mobilePhone || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        // {
        //     title: '电话',
        //     dataIndex: 'fixedPhone',
        //     key: 'fixedPhone',
        //     scopedSlots: {
        //         filterDropdown: 'filterDropdown',
        //         filterIcon: 'filterIcon',
        //         filtered: true,
        //     },
        //     filteredValue: filteredInfo.fixedPhone || [],
        //     sorter: true,
        //     sortDirections: ["descend", "ascend", "descend"]
        // },
        {
            title: '负责人邮箱',
            dataIndex: 'email',
            key: 'email',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.email || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '对应销售',
            dataIndex: 'sales.name',
            key: 'salesName'
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
